<div [ngStyle]="{ padding: '20px' }">
  @if (title) {
    <h3>{{ title}}</h3>
  }
  @if (subtitle) {
    <p>{{ subtitle }}</p>
  }
  <ng-content></ng-content>
</div>
